const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "29-Check List") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_29-Check_List",
    "data-name": "29-Check List"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15,
    width: 8,
    height: 4,
    rx: 1,
    ry: 1,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,11V23a3,3,0,0,1-3,3H37a3,3,0,0,1-3-3V11H54Zm-6,7V16a1,1,0,0,0-1-1H41a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h6A1,1,0,0,0,48,18Z",
    style: {
      fill: "#e3a76f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,7v3a1,1,0,0,1-1,1H49l5-5h1A1,1,0,0,1,56,7Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54 6 49 11 44 11 49 6 54 6",
    style: {
      fill: "#c18f5f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49 6 44 11 39 11 44 6 49 6",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44 6 39 11 34 11 39 6 44 6",
    style: {
      fill: "#c18f5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,6l-5,5H33a1,1,0,0,1-1-1V7a1,1,0,0,1,1-1Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 11,
    width: 20,
    height: 3,
    style: {
      fill: "#c39160"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.55,32.95a2,2,0,0,1,0,2.83L48.42,37.9,45.6,35.08l2.12-2.13a2.178,2.178,0,0,1,.66-.44A2.006,2.006,0,0,1,50.55,32.95Z",
    style: {
      fill: "#7e8596"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48 38.33 36.4 49.92 31.45 52.05 33.58 47.1 45.6 35.08 48.42 37.9 48 38.33",
    style: {
      fill: "#dce1eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,48v2a3,3,0,0,1-3,3H13a2.993,2.993,0,0,1-2.12-.88L11,52l6-6,.12-.12A2.993,2.993,0,0,1,18,48Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,45a2.993,2.993,0,0,1,2.12.88L17,46l-6,6-.12.12A2.993,2.993,0,0,1,10,50V48a3,3,0,0,1,3-3Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,36v2a3,3,0,0,1-3,3H13a2.993,2.993,0,0,1-2.12-.88L11,40l6-6,.12-.12A2.993,2.993,0,0,1,18,36Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,33a2.993,2.993,0,0,1,2.12.88L17,34l-6,6-.12.12A2.993,2.993,0,0,1,10,38V36a3,3,0,0,1,3-3Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,24v2a3,3,0,0,1-3,3H13a2.993,2.993,0,0,1-2.12-.88L11,28l6-6,.12-.12A2.993,2.993,0,0,1,18,24Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,21a2.993,2.993,0,0,1,2.12.88L17,22l-6,6-.12.12A2.993,2.993,0,0,1,10,26V24a3,3,0,0,1,3-3Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,1V13a2.938,2.938,0,0,1-3,3H4Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,32l.38.51a2.178,2.178,0,0,0-.66.44L45.6,35.08,33.58,47.1l-2.13,4.95,4.95-2.13L48,38.33V54a5,5,0,0,1-5,5H9a5,5,0,0,1-5-5V16H16a2.938,2.938,0,0,0,3-3V1H43a5,5,0,0,1,5,5H33a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h1V23a3,3,0,0,0,3,3H48ZM18,50V48a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3h2A3,3,0,0,0,18,50Zm0-12V36a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3h2A3,3,0,0,0,18,38Zm0-12V24a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3h2A3,3,0,0,0,18,26Z",
    style: {
      fill: "#ffe45c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,16V1H19V13a2.938,2.938,0,0,1-3,3H4v3H19A2.938,2.938,0,0,0,22,16Z",
    style: {
      fill: "#ffc247"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,20H13a4,4,0,0,0-4,4v2a4,4,0,0,0,4,4h2a4,4,0,0,0,4-4V24a4,4,0,0,0-4-4Zm-4,4a2,2,0,0,1,2-2h2a1.985,1.985,0,0,1,.511.075l-4.436,4.436A1.979,1.979,0,0,1,11,26Zm6,2a2,2,0,0,1-2,2H13a1.985,1.985,0,0,1-.511-.075l4.436-4.436A1.979,1.979,0,0,1,17,24Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,32H13a4,4,0,0,0-4,4v2a4,4,0,0,0,4,4h2a4,4,0,0,0,4-4V36a4,4,0,0,0-4-4Zm-4,4a2,2,0,0,1,2-2h2a1.985,1.985,0,0,1,.511.075l-4.436,4.436A1.979,1.979,0,0,1,11,38Zm6,2a2,2,0,0,1-2,2H13a1.985,1.985,0,0,1-.511-.075l4.436-4.436A1.979,1.979,0,0,1,17,36Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,26H23a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,38H23a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,24h4a1,1,0,0,0,0-2H23a1,1,0,0,0,0,2Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,36h4a1,1,0,0,0,0-2H23a1,1,0,0,0,0,2Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,44H13a4,4,0,0,0-4,4v2a4,4,0,0,0,4,4h2a4,4,0,0,0,4-4V48a4,4,0,0,0-4-4Zm-4,4a2,2,0,0,1,2-2h2a1.985,1.985,0,0,1,.511.075l-4.436,4.436A1.979,1.979,0,0,1,11,50Zm6,2a2,2,0,0,1-2,2H13a1.985,1.985,0,0,1-.511-.075l4.436-4.436A1.979,1.979,0,0,1,17,48Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,50H23a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,46H23a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,5H48.91A6.006,6.006,0,0,0,43,0H19c-.022,0-.041.011-.063.013a1.008,1.008,0,0,0-.261.052A.91.91,0,0,0,18.3.29l0,0-15,15,0,.005a1,1,0,0,0-.191.283.948.948,0,0,0-.033.094,1,1,0,0,0-.054.265c0,.022-.012.04-.012.061V54a6.006,6.006,0,0,0,6,6H43a6.006,6.006,0,0,0,6-6V38.743l2.257-2.256A3,3,0,0,0,49,31.373V27h2a4,4,0,0,0,4-4V12a2,2,0,0,0,2-2V7A2,2,0,0,0,55,5Zm-8.586,5,3-3h2.172l-3,3Zm-5,0,3-3h2.172l-3,3Zm-5,0,3-3h2.172l-3,3Zm-2.828,0H33V7h3.586ZM18,3.414V13a1.883,1.883,0,0,1-2,2H6.414Zm27.6,33.08,1.41,1.41L35.829,49.077l-2.468,1.062,1.062-2.468Zm4.238-2.841a1,1,0,0,1,.007,1.418l-1.421,1.42-1.412-1.412,1.4-1.4a1.151,1.151,0,0,1,.344-.237A1,1,0,0,1,49.838,33.653Zm-2.794-1.435c-.011.01-.022.016-.033.027L32.873,46.393a1,1,0,0,0-.212.312l-2.13,4.95a1,1,0,0,0,1.315,1.313l4.95-2.13a.968.968,0,0,0,.311-.211L47,40.741V54a4,4,0,0,1-4,4H9a4,4,0,0,1-4-4V17H16a3.887,3.887,0,0,0,4-4V2H43a4,4,0,0,1,3.858,3H33a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2V23a4,4,0,0,0,4,4H47v5A.937.937,0,0,0,47.044,32.218ZM53,23a2,2,0,0,1-2,2H37a2,2,0,0,1-2-2V12H53Zm2-13H51.414l3-3H55Z",
    style: {
      fill: "#2b1505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,14H41a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V16A2,2,0,0,0,47,14Zm0,4-6,0V16h6Z",
    style: {
      fill: "#2b1505"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/선행검증.60054e5374d47a999b3da829bc04183f.svg";
export { ForwardRef as ReactComponent };